import { MimeType } from '../../../../../common/media/mimeConstants';
import stripFileExtension from '../../../../../common/files/stripFileExtension';
import getFilenameFromUrl from '../../../../../common/files/getFilenameFromUrl';
import { replaceFileExtension } from '../imageModalFileUtils';

export type BackgroundRemovalOutputFormat = 'png' | 'webp';

/**
 * Background removal needs a format that supports transparency.
 * Preserve WebP when the source already uses it; otherwise fall back to PNG.
 */
export const getBackgroundRemovalOutputFormat = (imageBlob: Blob): BackgroundRemovalOutputFormat =>
    imageBlob.type === MimeType.WEBP ? 'webp' : 'png';

export const getBackgroundRemovalMimeType = (outputFormat: BackgroundRemovalOutputFormat): string =>
    outputFormat === 'webp' ? MimeType.WEBP : MimeType.PNG;

/**
 * Update the filename extension so uploads match the generated blob type.
 */
export const getOutputFilename = (fileName: string, blob: Blob): string => {
    return replaceFileExtension(fileName, getBackgroundRemovalOutputFormat(blob));
};

/**
 * Build a stable filename for background-removed outputs.
 */
export const getBackgroundRemovedFilename = (url: string, imageType: string, imageBlob: Blob): string => {
    const originalFilename = getFilenameFromUrl(url, imageType);
    const baseFilename = stripFileExtension(originalFilename) || 'image';
    const outputFormat = getBackgroundRemovalOutputFormat(imageBlob);

    return `${baseFilename}-background-removed.${outputFormat}`;
};
